import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  isGreen = false;

  @Input() activeStep: number = 1;

  actualStep = [

    'Datos inquilino',
    'Verificación número',
    'Validación identidad',
    'Firma contrato',
  ]

  actualStepMovil = [

    'Datos inquilino',
    'Verificación ',
    'Validación identidad',
    'Firma contrato',
  ]

  nextStep = [

    'Verificación número',
    'Validación identidad',
    'Firma contrato',
    'Firma contrato'
  ]

  nextStepMovil = [

    'Verificación',
    'Validación identidad',
    'Firma contrato',
    'Firma contrato'
  ]


  constructor() { }

  ngOnInit(): void { }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  getCurrentSteps(): string[] {
    return this.isMobile() ? this.actualStepMovil : this.actualStep;
  }
}
